import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import { useStore } from '@modules';

import { getOperations } from '@selectors';

import style from './Title.scss';

const cn = bemCssModules(style, 'Title');
const ti = getTestId('Title');

const Title: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const [store] = useStore();
  const operations = getOperations(store);

  function getTitle() {
    switch (true) {
      case operations.sell:
      case operations.sell_with_new_card:
      case operations.accounts_sell_exchange:
        return t('payments_select.title.sell');
      case operations.withdraw:
        return t('payments_select.title.withdraw');
      case operations.deposit:
        return t('payments_select.title.deposit');
      default:
        return t('payments_select.title.buy');
    }
  }

  return (
    <small className={cn(null, [className])} data-testid={ti()}>
      {getTitle()}
    </small>
  );
};

export default Title;
